/**
 * Created by dafre on 5/11/2017.
 */

export class WebGLBufferEnh {
  buffer : WebGLBuffer;
  itemSize : number;
  numItems : number;
}



// WEBPACK FOOTER //
// ./src/app/WebGLBufferEnh.ts